
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/stayhousedbayarea/assessment",
      function () {
        return require("private-next-pages/stayhousedbayarea/assessment.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/stayhousedbayarea/assessment"])
      });
    }
  